module.exports = __webpack_public_path__ + "static/CHF-2-front-be45d9e2eb9a6ff9a115608976c64eb5.png";